import React from 'react';

import { Typography, Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { ReactComponent as CloseIcon } from '../../../../common/assets/icons/close_icon.svg';
import { ReactComponent as DotIcon } from '../../../../common/assets/icons/dot_icon.svg';
import { SelectableCode } from '../../../../common/types/Codes';
import { Modifier } from '../../../types/Modifier';

type Props = {
  code: SelectableCode;
  onRemove: (code: SelectableCode) => void;
};

const MiniCPTCode: React.FC<Props> = ({ code, onRemove }) => {
  const modifiersText = (modifiers: string[] | Modifier[]) => {
    if (code.modifiers.length === 0) return '';
    return `${modifiers.join('; ')}`;
  };

  const hasModifiers = code.modifiers.length > 0;

  const multiplierText = (multiplier: number) => {
    return `x${multiplier}`;
  };

  return (
    <Box
      sx={{
        borderRadius: '16px',
        backgroundColor: '#D9E9ED',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          padding: '4px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <Typography
          color='#266071'
          fontWeight={500}
          fontSize={14}
          sx={{
            paddingLeft: '10px',
          }}
        >
          {code.code}
        </Typography>
        {hasModifiers && (
          <>
            <DotIcon
              style={{
                width: '3px',
                height: '3px',
              }}
            />
            <Typography color='secondary' fontWeight={500} fontSize={14}>
              {modifiersText(code.modifiers)}
            </Typography>
          </>
        )}
        <DotIcon
          style={{
            width: '3px',
            height: '3px',
          }}
        />
        <Typography color='secondary' fontWeight={500} fontSize={14}>
          {multiplierText(code.multiplier)}
        </Typography>
      </Box>
      <IconButton
        onClick={() => onRemove(code)}
        sx={{
          width: '28px',
          height: '28px',
          padding: '8px',
          marginRight: '2px',
          marginLeft: '2px',
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default MiniCPTCode;
